<template>
  <div class="home-wrap" @wheel="wheel">
    <div ref="contaner" class="contaner">
      <part1 :animation="showData[0]" :showIndex="showIndex"></part1>
      <part2 :flag="showBg[1]"></part2>
      <part3 :flag="showBg[2]"></part3>
      <part4 :flag="showBg[3]"></part4>
      <part5 :flag="showBg[4]" :renderFlag="part5_render"></part5>
      <part6 :flag="showBg[5]"></part6>
    </div>
    <div class="cir">
      <circular :color="cirColor" :circles="getCir" @update:showIndex="val => clickCir(val)"></circular>
    </div>
  </div>
</template>

<script>
  import Part1 from "../part1/Part1";
  import Part2 from "../part2/Part2";
  import Circular from "../plug/Circular";
  import Part3 from "../part3/Part3";
  import Part4 from "../part4/Part4";
  import Part5 from "../part5/Part5";
  import Part6 from "../part6/Part6";
  import bus from '../../assets/js/bus';

  export default {
    components: {
      Part6,
      Part5,
      Part4,
      Part3,
      Circular,
      Part2,
      Part1
    },
    name: "home",
    data() {
      return {
        flag: true,
        part5_render: false,
        pageNum: 6,
        showData: [true, false, false, false, false, false],
        showBg: [true, false, false, false, false, false]
      }
    },
    created() {
      this.showBg[bus.showIndex] = true;
    },
    mounted() {
      this.clickCir(bus.showIndex);
      let that = this;
      bus.$on('showIndexChange', function () {
        that.clickCir(bus.showIndex);
      });
      window.onresize = function () {
        //窗口大小改变 ，重新渲染part5
        bus.$emit('resize');
      }
    },
    methods: {
      clickCir(index) {
        this.showData[bus.showIndex] = false;
        bus.showIndex = index;
        this.showData[bus.showIndex] = true;
        this.showBg[bus.showIndex] = true;
        let dis = -100 * bus.showIndex;
        document.getElementsByClassName('contaner')[0].style.transform = "translateY(" + dis + "%)";
      },
      wheel(ev) {
        ev = ev || window.event;
        if (this.flag) {
          this.flag = false;
          if (ev.deltaY > 0 && bus.showIndex < this.pageNum - 1) {
            this.showData[bus.showIndex] = false;
            bus.showIndex++;
            this.showData[bus.showIndex] = true;
            this.showBg[bus.showIndex] = true;
          } else if (ev.deltaY < 0 && bus.showIndex > 0) {
            this.showData[bus.showIndex] = false;
            bus.showIndex--;
            this.showData[bus.showIndex] = true;
            this.showBg[bus.showIndex] = true;
          } else {
            this.flag = true;
            return;
          }
          let dis = -100 * bus.showIndex;
          document.getElementsByClassName('contaner')[0].style.transform = "translateY(" + dis + "%)";
          let _this = this;
          setTimeout(() => {
            _this.flag = true
          }, 500);
        }
      }
    },
    computed: {
      getCir() {
        let arr = [];
        for (let i = 0; i < this.pageNum; i++) {
          if (i === bus.showIndex) {
            arr.push({choice: true, black: true, name: ''});
          } else {
            arr.push({choice: false, black: true, name: ''});
          }
        }
        arr[0].black = false;
        arr[2].black = false;
        arr[4].black = false;
        arr[0].name = '首页';
        arr[1].name = '生态';
        arr[2].name = '产品';
        arr[3].name = '服务';
        arr[4].name = '案例';
        arr[5].name = '关于我们';
        return arr;
      }
      ,
      cirColor() {
        let color = [false, true, false, true, false, true];
        return color[bus.showIndex];
      }
      ,
      showIndex() {
        return bus.showIndex;
      }
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap {
    height: 100%;
    overflow: hidden;
    .contaner {
      height: 100%;
      position: relative;
      transition: all 0.5s ease;
    }
    .cir {
      width: 6%;
      min-width: 118px;
      position: absolute;
      right: 1%;
      top: 50%;
      transform: translateY(-50%);
      z-index: 100;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue